(function () {
  // Södermalm, Stockholm -- matches the STHLM clock's timezone (header-clock.liquid).
  // daily=sunrise,sunset (+timezone, so those come back as Stockholm local
  // time already) feeds both the twilight periods and the real-darkness
  // day/night boundary layout/theme.liquid's applyPeriod/applyModePreference
  // compute -- see that file for why the computation itself lives there
  // rather than here.
  var API_URL = 'https://api.open-meteo.com/v1/forecast?latitude=59.31&longitude=18.07&current_weather=true&daily=sunrise,sunset&timezone=Europe/Stockholm';
  var CACHE_MAX_AGE_MS = 30 * 60 * 1000;
  var PERIOD_RECHECK_MS = 60 * 1000;

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  // WMO weather codes, as returned by Open-Meteo's current_weather.weathercode
  // -- mapped down to this theme's five named sky states. Codes not listed
  // (fog 45/48, thunderstorm 95/96/99) fall in with their closest visual
  // match rather than getting a state of their own, per the brief's call to
  // fall back rather than add unbounded new states.
  function mapWeatherCodeToSky(code) {
    if (code === 0 || code === 1) { return 'clear'; }
    if (code === 2) { return 'clouds'; }
    if (code === 3 || code === 45 || code === 48) { return 'overcast'; }
    if (
      code === 51 || code === 53 || code === 55 ||
      code === 56 || code === 57 ||
      code === 61 || code === 63 || code === 65 ||
      code === 66 || code === 67 ||
      code === 80 || code === 81 || code === 82 ||
      code === 95 || code === 96 || code === 99
    ) {
      return 'rain';
    }
    if (code === 71 || code === 73 || code === 75 || code === 77 || code === 85 || code === 86) {
      return 'snow';
    }
    return 'clear';
  }

  function applySky(sky) {
    document.documentElement.setAttribute('data-weather', sky);
  }

  // --- TEMPORARY DEV TOOL, remove once a permanent state-preview tool
  // exists (tracked as "2b") -------------------------------------------
  // ?sky=<state> URL override, for previewing a sky state (rain, snow,
  // overcast, goldenhour, dusk, ...) without waiting for real Stockholm
  // weather/time to match. Valid states are read straight off the actual
  // sky--X layers rendered in the DOM (header-sky.liquid's
  // `.header-sky__layer sky--X` divs) rather than a hardcoded list here
  // -- so a later state is accepted automatically the moment its layer
  // markup exists, no change needed in this file. An unrecognized/
  // misspelled ?sky= value is treated as "no override" (falls through to
  // the real cache/fetch path below), not an error.
  //
  // Two axes, one URL param: goldenhour/dusk are twilight-TINT layers
  // (data-period), not weather backdrops (data-weather) -- see
  // layout/theme.liquid's applyPeriod comment for why those are separate
  // attributes. header-sky.liquid marks each period layer with a bare
  // data-sky-period attribute so this can tell which attribute a given
  // ?sky= value actually belongs to without hardcoding either list.
  // Forcing data-weather to 'clear' alongside a period override (rather
  // than leaving whatever real/cached weather was already showing) keeps
  // the preview clean and isolated -- exactly what ?sky=rain or
  // ?sky=snow already does for the weather axis.
  function getSkyOverrideFromURL() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return null;
    }

    var requested = params.get('sky');
    if (!requested) { return null; }

    var found = null;
    document.querySelectorAll('.header-sky .header-sky__layer').forEach(function (el) {
      el.classList.forEach(function (cls) {
        var match = /^sky--(.+)$/.exec(cls);
        if (match && match[1] === requested) {
          found = { value: requested, isPeriod: el.hasAttribute('data-sky-period') };
        }
      });
    });

    return found;
  }
  // ----------------------------------------------------------------------

  function applyTemp(tempC) {
    var value = Math.round(tempC) + '°';
    document.querySelectorAll('[data-header-temp-value]').forEach(function (el) {
      el.textContent = value;
    });
  }

  function readCache() {
    try {
      var raw = localStorage.getItem(window.EvaTheme.WEATHER_STORAGE_KEY);
      if (!raw) { return null; }
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.timestamp !== 'number' || typeof parsed.sky !== 'string') {
        return null;
      }
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function writeCache(sky, temp, sunset, sunrise) {
    try {
      localStorage.setItem(window.EvaTheme.WEATHER_STORAGE_KEY, JSON.stringify({
        sky: sky,
        temp: temp,
        sunset: sunset,
        sunrise: sunrise,
        timestamp: Date.now()
      }));
    } catch (e) {}
  }

  function isFresh(cache) {
    return !!cache && (Date.now() - cache.timestamp) < CACHE_MAX_AGE_MS;
  }

  function cachedSunset() {
    var cache = readCache();
    return cache && typeof cache.sunset === 'number' ? cache.sunset : null;
  }

  function cachedSunrise() {
    var cache = readCache();
    return cache && typeof cache.sunrise === 'number' ? cache.sunrise : null;
  }

  // Re-derives the currently stored mode preference and re-resolves
  // data-mode against it -- needed now (task: "dusk/night handoff")
  // because getAutoMode is sunset/sunrise-anchored, not just a clock
  // check, so a long-lived page view needs data-mode itself
  // re-evaluated periodically, the same way applyPeriod already is.
  function refreshMode() {
    var preference = null;
    try { preference = localStorage.getItem(window.EvaTheme.STORAGE_KEY); } catch (e) {}
    window.EvaTheme.applyModePreference(preference, cachedSunset(), cachedSunrise());
  }

  function fetchWeather() {
    fetch(API_URL)
      .then(function (res) {
        if (!res.ok) { throw new Error('open-meteo: bad response'); }
        return res.json();
      })
      .then(function (data) {
        var current = data && data.current_weather;
        if (!current || typeof current.weathercode !== 'number' || typeof current.temperature !== 'number') {
          throw new Error('open-meteo: unexpected payload');
        }
        var sky = mapWeatherCodeToSky(current.weathercode);
        var sunset = window.EvaTheme.parseISOMinutes(data.daily && data.daily.sunset && data.daily.sunset[0]);
        var sunrise = window.EvaTheme.parseISOMinutes(data.daily && data.daily.sunrise && data.daily.sunrise[0]);

        applySky(sky);
        applyTemp(current.temperature);
        window.EvaTheme.applyPeriod(sunset);
        writeCache(sky, current.temperature, sunset, sunrise);
        // A fresh sunset/sunrise reading can also change which side of
        // the night boundary "now" falls on (task: "dusk/night
        // handoff") -- refreshMode re-reads this same cache via
        // cachedSunset()/cachedSunrise(), just written above.
        refreshMode();
      })
      .catch(function () {
        // Silent fallback, per spec -- only apply it if nothing (not even a
        // stale cache) is already on screen; a stale reading is still more
        // accurate than resetting to clear on every transient network blip.
        var cache = readCache();
        if (!cache) {
          applySky('clear');
        }
        // Twilight still needs to resolve to SOMETHING even on total
        // failure -- applyPeriod's own fallback windows handle a null
        // sunset, so this is safe whether or not `cache` exists.
        window.EvaTheme.applyPeriod(cachedSunset());
        refreshMode();
      });
  }

  ready(function () {
    if (!window.EvaTheme) { return; }

    // Dev override active (see getSkyOverrideFromURL above): apply it
    // and stop -- no cache read, no cache write, no fetch, no periodic
    // re-check. The temp badge is deliberately left at its markup
    // default (--°, snippets/header-status-strip.liquid) rather than
    // showing a real or stale reading alongside a forced sky state,
    // which would look like it belonged to the override.
    var override = getSkyOverrideFromURL();
    if (override) {
      if (override.isPeriod) {
        applySky('clear');
        document.documentElement.setAttribute('data-period', override.value);
      } else {
        applySky(override.value);
        document.documentElement.removeAttribute('data-period');
      }
      return;
    }

    var cache = readCache();
    if (cache) {
      applySky(cache.sky);
      applyTemp(cache.temp);
    } else {
      applySky('clear');
    }
    window.EvaTheme.applyPeriod(cache && typeof cache.sunset === 'number' ? cache.sunset : null);
    refreshMode();

    if (!isFresh(cache)) {
      fetchWeather();
    }

    // Sunset barely moves day to day, so re-fetching isn't needed for
    // this -- but "now" changes every second, so a long-lived page view
    // (someone leaves the tab open through sunset, or through the real
    // night boundary -- see refreshMode) still needs both the twilight
    // period AND data-mode itself re-evaluated periodically against
    // whatever sunset/sunrise is cached, independent of the weather
    // fetch/cache-freshness cycle above. Same cadence as
    // header-clock.js's own minute tick.
    setInterval(function () {
      window.EvaTheme.applyPeriod(cachedSunset());
      refreshMode();
    }, PERIOD_RECHECK_MS);
  });
})();
